const RETURN_PATH_KEY = 'nava-backoffice-return-path';

export function getCurrentReturnPath(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function setReturnPath(path: string): void {
  sessionStorage.setItem(RETURN_PATH_KEY, path);
}

export function consumeReturnPath(): string {
  const value = sessionStorage.getItem(RETURN_PATH_KEY);
  sessionStorage.removeItem(RETURN_PATH_KEY);
  return value && value.startsWith('/') ? value : '/dashboard';
}
